export default __webpack_public_path__ + "static/media/onas.2719bd41.jpg";